export const claimSettlementTypeDef = `
  id
  name
`;
